<template>
  <div></div>
</template>
<script>

export const helpExploreScience1 = 'Analyse global scientific and technological landscapes, find most relevant experts using our search engine'
export const helpExploreScience2 = 'Analyse global scientific and technological landscape using academic publication databases'
export const helpExploreScienceTechTrans = 'Analyse global scientific and technological landscape, find most relevant experts and companies using our search engine to test or propose the tech offer'
export const helpExplorePatents = 'Explore intellectual property landscape using patent databases'
export const helpExploreEcosystems = 'Discover the ecosystems related to your problem space through company databases'

export const helpQuestion = 'Articulate question to be sent to Experts'
export const helpContact = 'Prepare and manage emails to experts'
export const helpInteract = 'Keep track of interactions with experts'
export const helpReport = 'Prepare automated project report'
export const helpReportProtect = 'Prepare automated project report & protect it with the blockchain'
export const helpProtect = 'Protect your files by recording them on the blockchain. You can later generate a proof of existence.<br> For more details, consult the Assistance'

export const helpTechTrans = 'Articulate the Tech offer. It can be revised as much as needed.'

export default {
  components: {},
  name: 'ProjectDetailsTour',
  props: []
}
</script>



// WEBPACK FOOTER //
// src/components/tour/ProjectDetailsTour.vue